import { BaseButton, type BaseButtonProps } from '@/components/common/base-button';
import clsx from 'clsx';
import styles from './styles.module.scss';

type Props = BaseButtonProps & {
    icon?: React.ReactNode;
};

export const ToggleCategoryButton = ({ children, icon, className, ...props }: Props) => {
    return (
        <BaseButton {...props} className={clsx(styles['toggle-category-button'], className && className)}>
            {icon && <span className={styles['toggle-category-button__icon']}>{icon}</span>}
            {children}
        </BaseButton>
    );
};
